import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Menu, Search } from 'lucide-react';
const NAV_ITEMS = [{
  label: 'Essays',
  href: '/#essays',
  internal: false
}, {
  label: 'Field Notes',
  href: '/#field-notes',
  internal: false
}, {
  label: 'Podcast',
  href: '/#podcast',
  internal: false
}, {
  label: 'About',
  href: '/about',
  internal: true
}];
export function Nav() {
  return <header className="sticky top-0 z-50 bg-cream border-thick-b" data-id="element-145">
      <div className="max-w-[96rem] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-146">
        <div className="flex justify-between items-center h-24" data-id="element-147">
          {/* Mobile Menu Button */}
          <div className="flex items-center lg:hidden" data-id="element-148">
            <button className="p-2 -ml-2 text-ink hover:text-accent transition-colors" data-id="element-149">
              <Menu className="w-8 h-8" data-id="element-150" />
            </button>
          </div>

          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-151">
            <Link to="/" aria-label="Skybox home" className="block" data-id="element-152">
              <img src="https://cdn.magicpatterns.com/uploads/7mG5TTriAZAq7vGVoPtWJ2/Black_logo_-_no_background.png" alt="Skybox" className="h-14 sm:h-16 w-auto" data-id="element-153" />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-10" data-id="element-154">
            {NAV_ITEMS.map(item => item.internal ? <Link key={item.label} to={item.href} className="text-base font-sans font-bold text-ink hover:text-accent transition-colors relative group uppercase tracking-wide" data-id="element-155">
                  {item.label}
                  <span className="absolute -bottom-2 left-0 w-0 h-[3px] bg-accent transition-all duration-300 group-hover:w-full" data-id="element-156"></span>
                </Link> : <a key={item.label} href={item.href} className="text-base font-sans font-bold text-ink hover:text-accent transition-colors relative group uppercase tracking-wide" data-id="element-157">
                  {item.label}
                  <span className="absolute -bottom-2 left-0 w-0 h-[3px] bg-accent transition-all duration-300 group-hover:w-full" data-id="element-158"></span>
                </a>)}
          </nav>

          {/* Right Actions */}
          <div className="flex items-center space-x-6" data-id="element-159">
            <button className="hidden sm:block p-2 text-ink hover:text-accent transition-colors" data-id="element-160">
              <Search className="w-6 h-6 stroke-[3]" data-id="element-161" />
            </button>
            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="bg-accent text-cream px-6 py-3 text-sm font-sans font-bold uppercase tracking-widest hover:bg-accent-hover transition-colors border-2 border-transparent hover:border-ink" data-id="element-162">
              Subscribe
            </motion.button>
          </div>
        </div>
      </div>
    </header>;
}